import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useInfiniteHits } from "react-instantsearch";
import NoResultsMessage from "../../algolia_search/no_results_message";
import SearchLoadingCards from "./search_loading_cards";
import CompanySkeletonPage from "./company_skeleton_page";
import useInfiniteScroll from "../../hooks/use_infinite_scroll";
import CompanyCardGrid from "../card/CompanyCardGrid";
import CompanyCardList from "../card/CompanyCardList";
import companyListActionColumnWidth from "../card/listActionColumn";
import { listHeaderRowStyle } from "../../source_directory/utils";

function InfiniteHits({ viewMode = "grid" }) {
  const { hits, isLastPage, showMore } = useInfiniteHits();
  const hasMore = !isLastPage;
  const [lastTriggeredAt, scrollTriggerRef] = useInfiniteScroll({ hasMore });

  useEffect(() => {
    if (lastTriggeredAt > 0) showMore();
  }, [lastTriggeredAt, showMore]);

  if (viewMode === "list") {
    return (
      <>
        <NoResultsMessage hits={hits} />
        {hits.length > 0 && (
          <div className="sd-list-header-row" style={listHeaderRowStyle}>
            {/* "Company" spans the logo tile (44) + gap (16) + name column (180) = 240. */}
            <span style={{ flex: "0 0 240px" }}>Company</span>
            <span style={{ flex: "0 0 260px" }}>Tags</span>
            <span style={{ flex: 1 }}>About</span>
            <span aria-hidden="true" style={{ flex: `0 0 ${companyListActionColumnWidth()}px` }} />
          </div>
        )}
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <SearchLoadingCards />
          {hits.map((hit) => (
            <CompanyCardList key={hit.objectID} hit={hit} />
          ))}
        </div>
        {hasMore && <div ref={scrollTriggerRef} />}
      </>
    );
  }

  return (
    <>
      <NoResultsMessage hits={hits} />
      <div className="sd-cards-grid">
        <SearchLoadingCards />
        {hits.map((hit) => (
          <CompanyCardGrid key={hit.objectID} hit={hit} />
        ))}
      </div>
      {hasMore && (
        <div ref={scrollTriggerRef} className="sd-cards-grid sd-cards-grid--loading-more">
          <CompanySkeletonPage numberOfCards={3} singleRow />
        </div>
      )}
    </>
  );
}

InfiniteHits.propTypes = {
  viewMode: PropTypes.oneOf(["grid", "list"]),
};

export default InfiniteHits;
